export const waitlist = {
  extends: 'Flex',
  flow: 'column',
  align: 'center',
  height: '100%',
  flex: '1',

  onSubmit: async (ev, el, s) => {
    ev.preventDefault()
    const { email, name } = s.parse ? s.parse() : s
    await el.sdk.addToWaitlist({ email, name })
    el.router('/', el.getRoot())
    if (window.plausible) window.plausible('Signup to Waitlist')
  },

  Content: {
    tag: 'form',
    maxWidth: 'H',
    width: '100%',
    margin: 'auto',

    Hgroup: {
      margin: '- - C1',
      H: { text: '{{ auth.waitlist.heading | polyglot }}' },
      P: {
        text: '{{ auth.waitlist.body | polyglot }}'
      }
    },
    WaitlistForm: {
      margin: '- - - -Y2',
      gap: 'Z2'
    },
    ContinueButton: {
      type: 'submit',
      margin: 'C1 - - -Y2',
      text: '{{ auth.waitlist.submit | polyglot }}',
      theme: 'primary',
      minHeight: 'controlH',
      round: 'radiusPill',
      fontSize: 'Z2',
      fontWeight: '700'
    }
  },
  Footer: {}
}
